export default __webpack_public_path__ + "static/media/desktop_tc2_Hk.c27fa03e.webp";